import { db } from "../firebase";
import { collection, query, where, onSnapshot, limit } from 'firebase/firestore';
export const getMyShoppingList = async (getIdToken) => {
    try {
        const token = await getIdToken();
        if (!token) {
            throw new Error('Brak tokena uwierzytelniającego');
        }
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

        const response = await fetch(`${BACKEND_URL}/api/shopping-list/my-list`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.status === 404) {
            return null;
        }

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Nie udało się pobrać listy zakupów');
        }

        return data.list;
    } catch (error) {
        throw error;
    }
};

export const upsertShoppingList = async (listData, getIdToken) => {
    try {
        const token = await getIdToken();
        if (!token) {
            throw new Error('Brak tokena uwierzytelniającego');
        }
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

        const response = await fetch(`${BACKEND_URL}/api/shopping-list/upsert`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(listData)
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Nie udało się zapisać listy zakupów');
        }

        return data;
    } catch (error) {
        console.error('Error upserting shopping list:', error);
        throw error;
    }
};

export const updateListSettings = async (listId, settings, getIdToken) => {
    try {
        const token = await getIdToken();
        if (!token) {
            throw new Error('Brak tokena uwierzytelniającego');
        }
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

        const response = await fetch(`${BACKEND_URL}/api/shopping-list/edit/${listId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(settings)
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Nie udało się zaktualizować ustawień listy');
        }

        return data;
    } catch (error) {
        console.error('Error updating list settings:', error);
        throw error;
    }
};

export const updateSharedListSettings = async (shareId, settings, getIdToken) => {
    try {
        const token = await getIdToken();
        if (!token) {
            throw new Error('Brak tokena uwierzytelniającego');
        }
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

        const response = await fetch(`${BACKEND_URL}/api/shopping-list/update-shared-list-name`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                "shareId": shareId,
                "settings": settings
            })
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Nie udało się zaktualizować udostępnionej listy');
        }

        return data;
    } catch (error) {
        console.error('Error updating list settings:', error);
        throw error;
    }
};

export const getSharedList = async (shareId) => {
    try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

        const response = await fetch(`${BACKEND_URL}/api/shopping-list/get-list/${shareId}`, {
            method: 'GET'
        });

        if (response.status === 404) {
            return null;
        }

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || data.message || 'Nie udało się pobrać listy');
        }

        return data.success ? data.list : null;
    } catch (error) {
        console.error('Error fetching shared list:', error);
        throw error;
    }
};

export const getSharedLists = async (getIdToken) => {
    try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

        const token = await getIdToken();
        if (!token) {
            throw new Error('Brak tokena uwierzytelniającego');
        }

        const response = await fetch(`${BACKEND_URL}/api/shopping-list/get-shared-lists`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.status === 404) {
            return [];
        }

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Nie udało się pobrać list zakupów');
        }

        return data.lists;
    } catch (error) {
        console.error('Error fetching shared lists:', error);
        throw error;
    }
}

export const saveSharedList = async (listData, getIdToken) => {
    try {
        const token = await getIdToken();
        if (!token) {
            throw new Error('Brak tokena uwierzytelniającego');
        }
        
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
        const response = await fetch(`${BACKEND_URL}/api/shopping-list/save-shared`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(listData)
        });

        const data = await response.json();

        if (!response.ok) {
            // Jeśli to błąd 409 (duplikat), nie rzucaj wyjątku - to nie jest krytyczny błąd
            if (response.status === 409) {
                console.log('Lista już istnieje w historii użytkownika');
                return { success: true, alreadyExists: true };
            }
            throw new Error(data.error || data.message || 'Nie udało się zapisać listy');
        }

        return { success: true, data };
    } catch (error) {
        console.error('Error saving shared list:', error);
        throw error;
    }
}

export const updateSharedIngredients = async (shareId, ingredients, getIdToken) => {
    if (!shareId) return;

    try {
        const token = await getIdToken();
        if (!token) {
            throw new Error('Brak tokena uwierzytelniającego');
        }
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
        const response = await fetch(`${BACKEND_URL}/api/shopping-list/update-shared-ingredients`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                shareId: shareId,
                ingredients: ingredients
            })
        });

        if (!response.ok) {
            console.error('Nie udało się zaktualizować składników w Firestore');
        }
    } catch (error) {
        console.error('Błąd podczas aktualizacji składników:', error);
    }
};
export const subscribeToSharedList = (shareId, onUpdate, onError) => {
    if (!shareId) {
        onError(new Error('Brak identyfikatora listy'));
        return () => {};
    }

    try {
        const listsRef = collection(db, 'lists');
        const q = query(
            listsRef,
            where('shareId', '==', shareId),
            where('available', '==', true),
            limit(1)
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                if (snapshot.empty) {
                    onError(new Error('Lista nie została znaleziona lub nie jest dostępna'));
                    return;
                }

                const listDoc = snapshot.docs[0];
                const listData = listDoc.data();

                const list = {
                    id: listDoc.id,
                    name: listData.name,
                    ingredients: listData.ingredients || [],
                    editable: listData.editable,
                    available: listData.available,
                    shareId: listData.shareId,
                    sharedAt: listData.sharedAt ? formatTimestamp(listData.sharedAt) : null,
                    createdAt: listData.createdAt,
                    userId: listData.userId,
                    updatedAt: listData.updatedAt?.toDate()
                };
                onUpdate(list);
            },
            (error) => {
                console.error('Error listening to shared list:', error);
                onError(error);
            }
        );

        return unsubscribe;
    } catch (error) {
        console.error('Error setting up shared list listener:', error);
        onError(error);
        return () => {};
    }
};

// Dodaj nową funkcję do nasłuchiwania własnej listy
export const subscribeToMyShoppingList = (userId, shareId, onUpdate, onError) => {
    if (!userId || !shareId) {
        onError(new Error('Brak identyfikatora użytkownika lub listy'));
        return () => {};
    }

    try {
        const listsRef = collection(db, 'lists');
        const q = query(
            listsRef,
            where('userId', '==', userId),
            where('shareId', '==', shareId),
            limit(1)
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                if (snapshot.empty) {
                    console.log('Nie znaleziono własnej listy w czasie rzeczywistym');
                    return;
                }

                const listDoc = snapshot.docs[0];
                const listData = listDoc.data();

                const list = {
                    id: listDoc.id,
                    name: listData.name,
                    ingredients: listData.ingredients || [],
                    editable: listData.editable,
                    available: listData.available,
                    shareId: listData.shareId,
                    sharedAt: listData.sharedAt ? formatTimestamp(listData.sharedAt) : null,
                    createdAt: listData.createdAt,
                    userId: listData.userId,
                    updatedAt: listData.updatedAt?.toDate()
                };
                onUpdate(list);
            },
            (error) => {
                console.error('Error listening to my shopping list:', error);
                onError(error);
            }
        );

        return unsubscribe;
    } catch (error) {
        console.error('Error setting up my shopping list listener:', error);
        onError(error);
        return () => {};
    }
};

// Pomocnicza funkcja do formatowania timestamp
const formatTimestamp = (timestamp) => {
    if (!timestamp) return null;
    
    // Jeśli to Firestore Timestamp
    if (timestamp.toDate) {
        return formatToPolandTime(timestamp.toDate());
    }
    
    // Jeśli to już Date
    if (timestamp instanceof Date) {
        return formatToPolandTime(timestamp);
    }
    
    return null;
};

const formatToPolandTime = (date) => {
    if (!date) return null;

    const formatter = new Intl.DateTimeFormat('pl-PL', {
        timeZone: 'Europe/Warsaw',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: false
    });

    const parts = formatter.formatToParts(date);
    const day = parts.find(part => part.type === 'day').value;
    const month = parts.find(part => part.type === 'month').value;
    const year = parts.find(part => part.type === 'year').value;
    const hour = parts.find(part => part.type === 'hour').value;
    const minute = parts.find(part => part.type === 'minute').value;

    return `${day}.${month}.${year} ${hour}:${minute}`;
};

/**
 * Wysyła log do backendu
 * @param {string} message - Wiadomość do zalogowania
 * @param {object} metadata - Opcjonalne dodatkowe dane
 * @param {function} getIdToken - Funkcja pobierająca token użytkownika
 */
export const sendLog = async (message, metadata = null, getIdToken) => {
    try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
        const token = await getIdToken();

        const response = await fetch(`${backendUrl}/api/log`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                message,
                ...(metadata && { metadata })
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        return await response.json();

    } catch (error) {
        console.error('Błąd wysyłania logu:', error);
        return null;
    }
};